import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

/**
 *  AKADÁLYMENTESÍTÉSI NYILATKOZAT – nyilvános, bejelentkezés NÉLKÜL elérhető oldal (/akadalymentesseg).
 *
 *  Jogalap: 2018. évi LXXV. törvény (közszférabeli szervezetek honlapjainak és mobilalkalmazásainak
 *  akadálymentesítéséről) 3–4. §, a végrehajtási eljárás a 162/2019. (VII. 5.) Korm. rendelet szerint
 *  (ellenőrző szervezet: a digitális szolgáltatások felügyelete – DSZF). A szerkezet az EU
 *  mintanyilatkozatát követi: hatály → megfelelőségi státusz → nem akadálymentes tartalom →
 *  elkészítés → visszajelzés → végrehajtási eljárás.
 *
 *  A tartalom szándékosan statikus (nincs backend-hívás): kilépve, lejárt munkamenettel és
 *  hálózati hiba mellett is olvasható kell legyen. Ha a megfelelőség változik, a szöveget ÉS
 *  a `felulvizsgalat` dátumot is frissíteni kell (a törvény 4. § (3): rendszeres frissítés).
 */
@Component({
  selector: 'app-akadalymentesseg',
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule],
  templateUrl: './akadalymentesseg.component.html',
  styleUrls: ['./akadalymentesseg.component.scss'],
})
export class AkadalymentessegComponent {
  /** A nyilatkozat elkészítésének napja. */
  readonly keszult = '2026. november 1.';
  /** Az utolsó felülvizsgálat napja (módosításkor ezt is át kell írni). */
  readonly felulvizsgalat = '2026. november 1.';
  /** Az a cím, amelyen az oldalt most megnyitották – a nyilatkozat erre az installációra vonatkozik. */
  readonly cim = (() => { try { return window.location.host || ''; } catch { return ''; } })();
}
